import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil, withLatestFrom} from "rxjs";
import {TranslateService} from "@mangosoft/mango-layout";
import {ProcessI, TaskStateI} from "../../../infrastructure/interfaces/process.interface";
import {Store} from "@ngrx/store";
import {selectSelectedProcess} from "../../../infrastructure/store/process/process.selector";
import {ProcessResultI} from "../../../infrastructure/interfaces/process-result.interface";
import {
  selectLoadingBulkStatusProcessResult,
  selectSelectedProcessResults
} from "../../../infrastructure/store/process-result/process-result.selector";
import {TaskStatus} from "../../../infrastructure/interfaces/task.interface";
import {
  bulkStatusProcessResult,
  setLoadingBulkStatusProcessResult
} from "../../../infrastructure/store/process-result/process-result.actions";
import {AccessControlService} from "../../../infrastructure/services/access-control.service";

@Component({
  selector: 'app-process-status-bulk-action',
  templateUrl: './process-status-bulk-action.component.html',
  styleUrls: ['./process-status-bulk-action.component.scss']
})
export class ProcessStatusBulkActionComponent implements OnInit, OnDestroy {
  destroy$: Subject<void> = new Subject();
  language!: any;

  process: ProcessI | null = null;

  selectedProcessResults: ProcessResultI[] = [];

  state_list: TaskStateI[] = [];
  selected_state: TaskStateI | null = null;

  loadingBulkStatusProcessResult: boolean = false;

  hasPermissions: { value: boolean; message: string } = {
    value: true,
    message: ''
  };

  constructor(
    private store: Store<any>,
    private translateService: TranslateService,
    private accessControlService: AccessControlService,
  ) {
    this.translateService
      .init("process-manager")
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.language = data;
        this.getWritePermissions();
      });
  }

  ngOnInit() {

    this.store.select(selectSelectedProcessResults).pipe(
      takeUntil(this.destroy$),
      withLatestFrom(this.store.select(selectSelectedProcess))
    ).subscribe(([values, process]) => {
      this.process = process;
      this.selectedProcessResults = values;

      const mixedStatus: TaskStateI = {
        "key": TaskStatus.mixed,
        "icon": "",
        "color": "#8d8d8d",
        "fontColor": "#ffffff",
        "label": "Mixed",
        "message": "",
        "selected": false
      }

      if (this.selectedProcessResults.length > 0) {
        this.selectedProcessResults = values;

        const sameProcessStatus = this.selectedProcessResults.every(p => p.process_status.key === this.selectedProcessResults[0].process_status.key)

        this.state_list = sameProcessStatus ?
          this.process?.process_states?.states_list || [] :
          [mixedStatus, ...this.process?.process_states?.states_list || []];

        this.selected_state = sameProcessStatus ? this.selectedProcessResults[0].process_status : mixedStatus;
      }

      this.getWritePermissions();

    });

    this.store.select(selectLoadingBulkStatusProcessResult).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.loadingBulkStatusProcessResult = value
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getWritePermissions(){
    this.selectedProcessResults.some((value,index) => {

      const isProcessWritableByUserGroup = (this.accessControlService.getAuthUserData()?.scope || "").split(",").some((group: string) => (value?.acl?.write || []).includes(group));
      const isProcessWritableByUser = (value?.acl?.write || []).includes(this.accessControlService.getAuthUserData().username)

      if (!(isProcessWritableByUser || isProcessWritableByUserGroup)) {
        this.hasPermissions = {
          value: false,
          message: this.language.bulkProcessPermissionWrite
        }
      } else {
       this.hasPermissions = {
          value: true,
          message: ""
        }
      }

      return !(isProcessWritableByUser || isProcessWritableByUserGroup)
    })
  }

  processStatusChange(event: any) {
    this.selected_state = event;
    console.log("Bulk event => ", event)
    if (this.process && this.selected_state){
      this.state_list = this.process.process_states.states_list;
      this.store.dispatch(setLoadingBulkStatusProcessResult({status: true}));
      this.store.dispatch(bulkStatusProcessResult({
        processId: this.process.id,
        objectIds: this.selectedProcessResults.map(v=>v.id),
        status: this.selected_state
      }))
    }

  }
}
